import css from './vacancy-detail.module.scss';
import Tooltip from 'src/components/tooltip-wrapper/tooltip';
import { ReactComponent as CopyIcon } from 'src/assets/ContentCopy.svg';
import { ReactComponent as EmailIcon } from 'src/assets/email.svg';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

VacancyFooter.propTypes = {
  email: PropTypes.string.isRequired,
  mailDetails: PropTypes.string.isRequired,
  onSend: PropTypes.func.isRequired
};

export default function VacancyFooter({ email, mailDetails, onSend }) {
  function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    toast.success('Скопійовано в буфер обміну');
  }
  return (
    <section className={css.footer}>
      <div className={css.card}>
        <div className={css.info}>
          <p className={css.card_title}>Електронна адреса</p>
          <Tooltip text={`Відправити лист на ${email}`}>
            <p className={css.card_email} onClick={onSend} /* NOSONAR */>
              {email}
            </p>
          </Tooltip>
        </div>
        <div className={css.buttons}>
          <Tooltip text='Скопіювати електронну адреса'>
            <button tabIndex={0} className={css.action_icon} onClick={() => copyToClipboard(email)}>
              <CopyIcon />
            </button>
          </Tooltip>
          <Tooltip text='Відправити лист'>
            <button tabIndex={0} className={css.action_icon} onClick={onSend}>
              <EmailIcon />
            </button>
          </Tooltip>
        </div>
      </div>
      <div className={css.card}>
        <div className={css.info}>
          <p className={css.card_title}>Тема листа</p>
          <p className={css.card_info}>{mailDetails}</p>
        </div>
        <div className={css.buttons}>
          <Tooltip text='Скопіювати тему листа'>
            <button tabIndex={0} className={css.action_icon} onClick={() => copyToClipboard(mailDetails)}>
              <CopyIcon />
            </button>
          </Tooltip>
        </div>
      </div>
      <div className={css.card}>
        <div className={css.info}>
          <p className={css.card_title}>Що має бути вкладене до листа</p>
          <p className={css.card_info}>Резюме у форматі DOCX</p>
        </div>
      </div>
    </section>
  );
}
